import { useModal } from '../contexts';
import Modal from './Modal';

function UpgradeSuccessModal() {

  const { closeModal } = useModal();

  return (
    <Modal>
      <div className="flex flex-col items-center justify-center text-center bg-white p-8 pb-0 w-[600px] h-[400px]">
        <div className="text-4xl font-gilroy font-bold text-green">
          Success!
        </div>
        <div className="text-gray-600 font-semibold mt-1">
          You have successfully upgraded your Portant subscription
        </div>
        <button className='btn btn-blue w-[200px] mt-10' onClick={() => closeModal()}>
          Close
        </button>
      </div>
    </Modal>
  );
}

export default UpgradeSuccessModal;
